<template>
  <BasicLayout>
    <template #wrapper>
      <el-card class="box-card">
        <div slot="header" class="clearfix">
          <span>
            <el-page-header content="锦标赛" @back="goBack" />
            <CommonExport :id="aid" :export-title="'系数导出'" :import-title="'系数导入'" style="float: right" :import-p="'config:rewardBuildMasterEdit:import'" :export-p="'config:rewardBuildMasterEdit:export'" :get-table="getTables" :import-method="importActivtyStageCoefficientCfg" :export-method="exportStageCoefficientCfg" />
          </span>
        </div></el-card>

      <!--      <el-card>-->
      <!--        <act-reward-process :is-online="isOnline ===1" :aid="aid" :type="actType" />-->
      <!--      </el-card>-->
      <el-dialog
        title="提示"
        :visible.sync="dialogVisible"
        width="500px;"
      >
        <el-form :inline="true" class="demo-form-inline" style="margin: 10px 0px 0px 20px;">
          <el-form-item label="选择类型">
            <el-select v-model="levelFormData.type" style="width: 150px" placeholder="请选择">
              <el-option
                v-for="item in conditionType"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="数值">
            <el-input v-model.number="levelFormData.min_level" style="width: 100px;" placeholder="最小值" />
          </el-form-item>
          <el-form-item label="-">
            <el-input v-model.number="levelFormData.max_level" style="width: 100px;" placeholder="最大值" />
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="dialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="addLevel()">保存</el-button>
        </span>
      </el-dialog>

      <el-dialog
        title="提示"
        :visible.sync="dialogVisibleScoreEvent"
        width="500px"
      >
        <el-form :inline="true" class="demo-form-inline" style="margin: 10px 0px 0px 20px;">
          <el-form-item label="选择分组">
            <el-select v-model="scoreFormData.group" style="width: 150px" multiple placeholder="请选择">
              <el-option
                v-for="item in groups"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="dialogVisibleScoreEvent = false">取 消</el-button>
          <el-button type="primary" @click="addGroup()">保存</el-button>
        </span>
      </el-dialog>

      <el-card>
        <div style="margin-left: 50px;">
          <el-button v-permisaction="['config:rewardBuildMasterEdit:add']" type="primary" @click="beforeAddLevel()">添加等级</el-button>
        </div>

        <el-tabs v-model="levelActiveName" tab-position="left" style="height: 100%;" @tab-click="handleClick">
          <el-tab-pane v-for="(tabItem,index) in tabPane" :key="index" :name="tabItem.label" :label="getLabelName(tabItem.label)" @tab-remove="delCond">
            <template #label>
              <div>
                {{ getLabelName(tabItem.label) }}
              </div>
            </template>

            <el-tabs v-model="activeName" @tab-click="handleClick">
              <!--------  等级配置----->
              <el-form :inline="true">
                <el-form-item label="选择类型">
                  <el-select v-model="tabItem.type" style="width: 150px" placeholder="请选择" @change="(v)=>{return levelChangeType(v, tabItem.label)}">
                    <el-option
                      v-for="item in conditionType"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    />
                  </el-select>
                </el-form-item>
                <el-form-item label="数值范围">
                  <el-input v-model.number="tabItem.min_level" style="width: 100px;" placeholder="最小值" @change="(v)=>{return levelChange(v, 1,tabItem.type,tabItem.bak_min_level, tabItem.bak_max_level)}" />
                </el-form-item>
                <el-form-item label="-">
                  <el-input v-model.number="tabItem.max_level" style="width: 100px;" placeholder="最大值" @change="(v)=>{return levelChange(v, 0,tabItem.type,tabItem.bak_min_level, tabItem.bak_max_level)}" />
                </el-form-item>
                <el-button v-permisaction="['config:rewardBuildMasterEdit:add']" type="primary" @click="beforeAddLevel(tabItem.label, index)">添加等级2</el-button>
              </el-form>
              <!--------  等级配置----->

              <el-card v-if="tabItem.children.length > 0" class="box-card">
                <!-- 二级等级-->
                <el-tabs v-model="levelActiveName2" tab-position="left" style="height: 100%;" @tab-click="handleClick">
                  <el-tab-pane v-for="(tabItem1,index1) in tabItem.children" :key="index1" :name="tabItem1.label" :label="getLabelName(tabItem1.label)">
                    <template #label>
                      <div>
                        {{ getLabelName(tabItem1.label) }} <i class="el-icon-circle-close" style="color:red" @click="delChildren(tabItem.label, index1)" />
                      </div>
                    </template>
                    <el-form :inline="true">
                      <el-form-item label="选择类型">
                        <el-select v-model="tabItem1.type" style="width: 150px" placeholder="请选择" @change="(v)=>{return levelChangeType(v, tabItem.label,1,tabItem1.label,index1)}">
                          <el-option
                            v-for="item in conditionType"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value"
                          />
                        </el-select>
                      </el-form-item>
                      <el-form-item label="数值范围">
                        <el-input v-model.number="tabItem1.min_level" style="width: 100px;" placeholder="最小值" @change="(v)=>{return levelChange(v, 1,tabItem1.type,tabItem1.bak_min_level, tabItem1.bak_max_level,1,tabItem.label,tabItem1.label)}" />
                      </el-form-item>
                      <el-form-item label="-">
                        <el-input v-model.number="tabItem1.max_level" style="width: 100px;" placeholder="最大值" @change="(v)=>{return levelChange(v, 0,tabItem1.type,tabItem1.bak_min_level, tabItem1.bak_max_level,1,tabItem.label,tabItem1.label)}" />
                      </el-form-item>
                    <!--                      <el-button v-permisaction="['config:rewardBuildMasterEdit:add']" type="primary" @click="beforeAddLevel(tabItem1.label, index)">添加等级2</el-button>-->
                    </el-form>

                    <el-button style="margin: 10px 0 10px 0" @click="addScoreEvent(tabItem1.label,tabItem.label, index1)">+分组</el-button>
                    <el-form>
                      <el-row v-for="(scoreItem, scoreIndex) in tabItem1.data" :key="scoreIndex">
                        <el-card class="box-card" style="margin-top: 10px">
                          <div slot="header" class="clearfix" style="height: 60px;">
                            <el-form :inline="true">
                              <el-form-item label="选择分组">
                                <el-select v-model="scoreItem.group_bak" multiple placeholder="请选择" style="width: 500px;" @change="(v)=>{return groupChange(v,tabItem.label,scoreItem.group_name,1,index1,scoreIndex)}">
                                  <el-option
                                    v-for="item in groups"
                                    :key="item.value"
                                    :label="item.label"
                                    :value="item.value"
                                  />
                                </el-select>
                              </el-form-item>
                            </el-form>
                          </div>

                          <!--  修正系数-->
                          <el-table
                            :data="scoreItem.data[0].stageCoefficient"
                            border
                            style="width: 100%"
                          >
                            <el-table-column
                              v-for="(item, index) in stageCoefficientHeader"
                              :key="index"
                              :label="item"
                            >
                              <template slot-scope="scope">
                                {{ scope.row[index] }}
                              </template>
                            </el-table-column>
                          </el-table>
                          <!-- 修正系数-->

                          <el-form style="margin-top: 15px">
                            <el-row v-for="(item, score_index) in scoreItem.data" :key="score_index">
                              <el-tabs v-model="activeName" @tab-click="handleTableClick">
                                <el-tab-pane label="进度奖励配置" name="first">
                                  <el-row v-for="(items, stagesIndex) in item.rewards.stages" :key="stagesIndex">
                                    <el-form :inline="true">
                                      <el-form-item label="阶段" style="margin-top: 10px;">
                                        <el-input v-model.number="items.stage" style="width: 80px;" placeholder="阶段" />
                                      </el-form-item>
                                      <el-form-item label="步骤进度" style="margin-top: 10px;">
                                        <el-input v-model.number="items.stepnum" style="width: 80px;" placeholder="步骤" />
                                      </el-form-item>
                                      <el-form-item label="进度Bar" style="margin-top: 10px;">
                                        <el-input v-model.number="items.progressBarId" style="width: 80px;" placeholder="步骤" />
                                      </el-form-item>
                                      <el-form-item label="最低消耗体力" style="margin-top: 10px;">
                                        <el-input v-model.number="items.stageSpins" style="width: 80px;" placeholder="最低消耗体力" />
                                      </el-form-item>
                                      <el-form-item label="奖励" style="margin-top: 10px;">
                                        <ActReward :value="items.prize" />
                                      </el-form-item>
                                      <el-form-item style="margin-top: 10px;">
                                        <el-button v-permisaction="['config:rewardRankEdit:del']" type="danger" @click="delEvent1('stages',tabItem.label,index1,scoreIndex , 1, stagesIndex)">删除</el-button>
                                      </el-form-item>
                                    </el-form>
                                  </el-row>
                                  <el-button type="primary" style="margin-bottom: 10px" @click="addEvent('stages',tabItem.label,scoreIndex,1,index1)">+</el-button>
                                </el-tab-pane>
                                <el-tab-pane label="排行榜奖励配置" name="second">
                                  <el-row v-for="(items, rewardsIndex) in item.rewards.ranks" :key="rewardsIndex">
                                    <el-form :inline="true">
                                      <el-form-item label="排名" style="margin-top: 10px;">
                                        <el-input v-model.number="items.rankPos" style="width: 80px;" placeholder="名" />
                                      </el-form-item>
                                      <el-form-item label="奖励" style="margin-top: 10px;">
                                        <ActReward :value="items.prize" />
                                      </el-form-item>
                                      <el-form-item style="margin-top: 10px;">
                                        <el-button v-permisaction="['config:rewardRankEdit:del']" type="danger" @click="delEvent1('ranks',tabItem.label,index1,scoreIndex , 1, score_index)">删除</el-button>
                                      </el-form-item>
                                    </el-form>
                                  </el-row>
                                  <el-button type="primary" style="margin-bottom: 10px" @click="addEvent('ranks',tabItem.label,scoreIndex,1,index1)">+</el-button>
                                </el-tab-pane>
                              </el-tabs>
                            </el-row>
                            <el-button v-permisaction="['config:rewardRankEdit:add']" style="margin-top: 10px" type="primary" @click="onSubmit()">保存</el-button>
                            <el-button style="margin-top: 10px" type="danger" @click="delEvent(tabItem.label,scoreIndex,1,index1 )">删除</el-button>
                          </el-form>
                        </el-card>
                      </el-row>
                    </el-form>
                  </el-tab-pane>
                </el-tabs>
              <!-- 二级等级-->
              </el-card>
              <el-button style="margin: 10px 0 10px 0" @click="addScoreEvent(tabItem.label,'')">+分组</el-button>
              <el-form>
                <el-row v-for="(scoreItem, scoreIndex) in tabItem.data" :key="scoreIndex">
                  <el-card class="box-card" style="margin-top: 10px">
                    <div slot="header" class="clearfix" style="height: 60px;">
                      <el-form :inline="true">
                        <el-form-item label="选择分组">
                          <el-select v-model="scoreItem.group_bak" multiple placeholder="请选择" style="width: 500px;" @change="(v)=>{return groupChange(v,tabItem.label,scoreItem.group_name)}">
                            <el-option
                              v-for="item in groups"
                              :key="item.value"
                              :label="item.label"
                              :value="item.value"
                            />
                          </el-select>
                        </el-form-item>
                      </el-form>
                    </div>

                    <!--  修正系数-->
                    <el-table
                      :data="scoreItem.data[0].stageCoefficient"
                      border
                      style="width: 100%"
                    >
                      <el-table-column
                        v-for="(item, index) in stageCoefficientHeader"
                        :key="index"
                        :label="item"
                      >
                        <template slot-scope="scope">
                          {{ scope.row[index] }}
                        </template>
                      </el-table-column>
                    </el-table>
                    <!-- 修正系数-->

                    <el-form style="margin-top: 15px">
                      <el-row v-for="(item, score_index) in scoreItem.data" :key="score_index">
                        <el-tabs v-model="activeName" @tab-click="handleTableClick">
                          <el-tab-pane label="进度奖励配置" name="first">
                            <el-row v-for="(items, index111) in item.rewards.stages" :key="index111">
                              <el-form :inline="true">
                                <el-form-item label="阶段" style="margin-top: 10px;">
                                  <el-input v-model.number="items.stage" style="width: 80px;" placeholder="阶段" />
                                </el-form-item>
                                <el-form-item label="步骤进度" style="margin-top: 10px;">
                                  <el-input v-model.number="items.stepnum" style="width: 80px;" placeholder="步骤" />
                                </el-form-item>
                                <el-form-item label="进度Bar" style="margin-top: 10px;">
                                  <el-input v-model.number="items.progressBarId" style="width: 80px;" placeholder="步骤" />
                                </el-form-item>
                                <el-form-item label="最低消耗体力" style="margin-top: 10px;">
                                  <el-input v-model.number="items.stageSpins" style="width: 80px;" placeholder="最低消耗体力" />
                                </el-form-item>
                                <el-form-item label="奖励" style="margin-top: 10px;">
                                  <ActReward :value="items.prize" />
                                </el-form-item>
                                <el-form-item style="margin-top: 10px;">
                                  <el-button v-permisaction="['config:rewardRankEdit:del']" type="danger" @click="delEvent1('stages',tabItem.label,scoreIndex ,index111, 0)">删除</el-button>
                                </el-form-item>
                              </el-form>
                            </el-row>
                            <el-button type="primary" style="margin-bottom: 10px" @click="addEvent('stages',tabItem.label,scoreIndex,0)">+</el-button>
                          </el-tab-pane>
                          <el-tab-pane label="排行榜奖励配置" name="second">
                            <el-row v-for="(items, index222) in item.rewards.ranks" :key="index222">
                              <el-form :inline="true">
                                <el-form-item label="排名" style="margin-top: 10px;">
                                  <el-input v-model.number="items.rankPos" style="width: 80px;" placeholder="名" />
                                </el-form-item>
                                <el-form-item label="奖励" style="margin-top: 10px;">
                                  <ActReward :value="items.prize" />
                                </el-form-item>
                                <el-form-item style="margin-top: 10px;">
                                  <el-button v-permisaction="['config:rewardRankEdit:del']" type="danger" @click="delEvent1('ranks',tabItem.label,scoreItem.group_name ,index222, 0)">删除</el-button>
                                </el-form-item>
                              </el-form>
                            </el-row>
                            <el-button type="primary" style="margin-bottom: 10px" @click="addEvent('ranks',tabItem.label,scoreIndex,0)">+</el-button>
                          </el-tab-pane>
                        </el-tabs>
                      </el-row>
                      <!--                      <el-button style="margin-top: 10px" type="primary" @click="addEvent(tabItem.label,scoreItem.group_name,scoreIndex,0)">+</el-button>-->
                      <el-button v-permisaction="['config:rewardBuildMasterEdit:add']" :disabled="isOnline === 1" style="margin-top: 10px" type="primary" @click="onSubmit()">保存</el-button>
                      <el-button :disabled="isOnline === 1" style="margin-top: 10px" type="danger" @click="delEvent(tabItem.label,scoreIndex)">删除</el-button>
                    </el-form>
                  </el-card>
                </el-row>
              </el-form>

            </el-tabs>
          </el-tab-pane>
        </el-tabs>
      </el-card>
      <el-card style="margin-top: 20px">
        <div slot="header" class="clearfix">
          <span>玩家分池/分组</span>
        </div>
        <el-form>
          <el-form-item label="分区类型" style="margin-top: 10px;">
            <el-select v-model.number="vipSet.setType" placeholder="请选择">
              <el-option
                v-for="item in vipType"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </el-form-item>
          <el-form-item v-if="vipSet.setType === 2" label="体力分块" style="margin-top: 10px;">
            <el-input v-for="(v,k) in vipSet.spinsSet" :key="k" v-model.number="vipSet.spinsSet[k]" style="width: 130px;margin-left: 10px" placeholder="体力分块" />
          </el-form-item>
          <el-form-item v-if="vipSet.setType === 2" label="停止区间" style="margin-top: 10px;">
            <el-input v-for="(v,k) in vipSet.spinsSetSpins" :key="k" v-model.number="vipSet.spinsSetSpins[k]" style="width: 130px;margin-left: 10px" placeholder="体力分块" />
          </el-form-item>
          <el-form-item v-if="vipSet.setType === 1" label="vip分块" style="margin-top: 10px;">
            <el-input v-for="(v,k) in vipSet.vipSet" :key="k" v-model.number="vipSet.vipSet[k]" style="width: 130px;margin-left: 10px" placeholder="vip分块" />
          </el-form-item>
          <el-form-item v-if="vipSet.setType === 1" label="vip区间" style="margin-top: 10px;">
            <el-input v-for="(v,k) in vipSet.vipSetSpins" :key="k" v-model.number="vipSet.vipSetSpins[k]" style="width: 130px;margin-left: 10px" placeholder="vip分块" />
          </el-form-item>
          <el-button v-permisaction="['config:rewardRankEdit:add']" :disabled="isOnline === 1" type="primary" @click="onSubmitVipSet()">保存</el-button>
        </el-form>
      </el-card>

      <el-card style="margin-top: 20px">
        <div slot="header" class="clearfix">
          <span>机器人配置</span>
        </div>
        <el-row v-for="(item, index) in vipSet.robot" :key="index">
          <el-form :inline="true">
            <el-form-item label="机器人ID">
              <el-input v-model.number="item.id" style="width: 130px;" placeholder="机器人ID" />
            </el-form-item>
            <!--                <el-form-item label="获得间隔时间" style="margin-top: 10px;">-->
            <!--                  <el-input v-model.number="item.stepnum" style="width: 80px;" placeholder="步骤" />-->
            <!--                </el-form-item>-->
            <!--                <el-form-item label="-" style="margin-top: 10px;">-->
            <!--                  <el-input v-model.number="item.stepnum" style="width: 80px;" placeholder="步骤" />-->
            <!--                </el-form-item>-->
            <el-form-item label="获得收集物数量">
              <el-input v-model.trim="item.co1" style="width: 80px;" placeholder="获得收集物数量" />
            </el-form-item>
            <el-form-item label="-">
              <el-input v-model.trim="item.co2" style="width: 80px;" placeholder="获得收集物数量" />
            </el-form-item>
            <el-form-item label="初始系值">
              <el-input v-model.number="item.pro" style="width: 80px;" placeholder="初始系值" />
            </el-form-item>
            <el-form-item label="停止目标值">
              <el-input v-model.number="item.num" style="width: 80px;" placeholder="停止目标值" />
            </el-form-item>
            <!--                <el-form-item label="-" style="margin-top: 10px;">-->
            <!--                  <el-input v-model.number="item.stageSpins" style="width: 80px;" placeholder="最低拥有体力" />-->
            <!--                </el-form-item>-->
            <el-form-item>
              <el-button v-permisaction="['config:rewardRankEdit:del']" type="danger" @click="delBot(index)">删除</el-button>
            </el-form-item>
          </el-form>
        </el-row>
        <el-button v-permisaction="['config:rewardRankEdit:del']" type="primary" @click="addBot()">+</el-button>
        <el-button v-permisaction="['config:rewardRankEdit:add']" :disabled="isOnline === 1" type="primary" @click="onSubmitVipSet()">保存</el-button>
      </el-card>

      <el-card style="margin-top: 20px">
        <div slot="header" class="clearfix">
          <span>机器人人数限制</span>
        </div>
        <el-form :inline="true">
          <el-row v-for="(item, index) in vipSet.rankLimit" :key="index">
            <el-form-item label="剩余小时数">
              <el-input v-model.number="item.time" style="width: 130px;margin-left: 10px" placeholder="剩余小时数" />
            </el-form-item>
            <el-form-item label="房间人数">
              <el-input v-model.number="item.limit" style="width: 130px;margin-left: 10px" placeholder="房间人数" />
            </el-form-item>
            <el-form-item>
              <el-button v-permisaction="['config:rewardRankEdit:del']" type="danger" @click="delRankLimit(index)">删除</el-button>
            </el-form-item>
          </el-row>
          <el-form-item style="margin-top: 10px;">
            <el-button v-permisaction="['config:rewardRankEdit:add']" type="primary" @click="addRankLimit()">+</el-button>
          </el-form-item>
        </el-form>
        <el-button v-permisaction="['config:rewardRankEdit:add']" :disabled="isOnline === 1" type="primary" @click="onSubmitVipSet()">保存</el-button>
      </el-card>
    </template>
  </BasicLayout>
</template>

<script>
import CommonExport from '@/components/CommonExport/index.vue'
import Vue from 'vue'
import { getChessBoardType, getRewardType } from '@/api/config/slot'
import {
  exportActivtyRewardCfg, exportStageCoefficientCfg, getActivtyAllList, getActivtyList,
  getActivtyRewardCfg, getActivityTypeToMap,
  getConditionTypesList, getStageCoefficientList,
  importActivtyRewardCfg, importActivtyStageCoefficientCfg, updateActivtyExtraData,
  updateActivtyRewardCfg
} from '@/api/config/activity-cfg'
import { getToken } from '@/utils/auth'
import { getUserTypeAllList } from '@/api/config/user-group-cfg'
import { getRewardListForType } from '@/utils'
import ActReward from '@/components/Reward/act.vue'
import ActRewardProcess from '@/components/actRewardProcess/index.vue'
export default {
  name: 'RewardBuilderMasterEdit',
  components: {
    ActRewardProcess,
    ActReward,
    CommonExport
  },
  data() {
    return {
      isOnline: 0,
      stageCoefficient: [],
      stageCoefficientHeader: [],
      ucType: 0,
      loading: false,
      headers: { 'Authorization': 'Bearer ' + getToken() },
      sys_app_logoAction: process.env.VUE_APP_BASE_API + '/api/v1/public/uploadFile',
      aid: 0,
      tabPane: [],
      shopSku: [],
      visibleArr: {},
      vipType: [
        {
          'value': 2,
          'label': '体力'
        }, {
          'value': 1,
          'label': 'vip积分'
        }],
      vipSet: {
        setType: 1,
        vipSet: [0, 0, 0, 0, 0, 0],
        spinsSet: [0, 0, 0, 0, 0, 0, 0, 0, 0],
        vipSetSpins: [0, 0, 0, 0, 0, 0],
        spinsSetSpins: [0, 0, 0, 0, 0, 0, 0, 0, 0],
        robot: [{ id: 1, pro: 0, num: 1, co1: 1, co2: 1 }],
        rankLimit: [
          { time: 1, limit: 1 }
        ]
      },
      tabPaneTemp: {
        label: '',
        type: '',
        bak_type: '',
        min_level: 0,
        max_level: 0,
        bak_min_level: 0,
        bak_max_level: 0,
        children: [],
        data: []
      },
      drawer: {},
      direction: 'rtl',
      rewardType: [],
      chessBoardType: [],
      groups: [
        { label: '默认分组', value: 0 }
        // { label: '免费玩家', value: 1 },
        // { label: '付费玩家', value: 2 }
      ],
      conditionType: [],
      actType: '',
      dialogVisible: false,
      dialogVisibleScoreEvent: false,
      levelFormData: {
        min_level: 0,
        max_level: 0,
        type: 'level',
        parent: '',
        index: 0
      },
      scoreFormData: {
        group: [],
        parent: '',
        group_name: '',
        group_bak: [],
        level_name: '',
        index: 0,
        event_name: ''
      },
      activeName: 'first',
      levelActiveName: '',
      levelActiveName2: '',
      copyFormData: {},
      formData: {},
      activtyToType: [],
      activtyToTypeId: [],
      activtyList: []
    }
  },
  created() {
    // this.getSkuList()
    this.getConditionTypeData()
    this.aid = this.$route.query.id
    this.actType = this.$route.query.type
    this.ucType = this.$route.query.uc_type
    this.isOnline = parseInt(this.$route.query.is_online)
    this.typeChange('')
    this.getTables()
    this.getGroup()
    this.getExtraData()
  },
  methods: {
    exportStageCoefficientCfg,
    importActivtyStageCoefficientCfg,
    beforeAddLevel(parent = '', index = -1) {
      this.dialogVisible = true
      this.levelFormData.parent = parent
      this.levelFormData.index = index
    },
    getConditionTypeData() {
      getConditionTypesList({ data: 1 }).then(res => {
        if (res.code === 200) {
          for (const i in res.data) {
            this.conditionType.push({ 'label': res.data[i], 'value': i })
          }
        }
      })
    },
    importUploadSuccess(response) {
      this.loading = true
      this.$refs['upload'].clearFiles()
      importActivtyRewardCfg({ type: this.actType, name: this.aid, data: response.data.path }).then(res => {
        // eslint-disable-next-line eqeqeq
        this.loading = false
        if (res.code === 200) {
          this.msgSuccess(res.msg)
          this.getTables()
        } else {
          this.msgError(res.msg)
        }
      })
    },
    exportData() {
      exportActivtyRewardCfg({ id: this.aid, type: this.actType }).then(res => {
        if (res.code === 200) {
          window.open(process.env.VUE_APP_BASE_API + '/' + res.data.path)
          this.msgSuccess(res.msg)
        } else {
          this.msgError(res.msg)
        }
      })
    },
    goBack() {
      this.$router.push({ path: '/config/activity-config/index' })
    },
    handleClose(done, levelName, scoreName, index) {
      this.drawer[levelName][scoreName][index].visible = false
    },
    onSubmit() {
      const postFormDataCondition = {}
      const _postData = []
      let levelIndex = 0
      for (const i in this.tabPane) {
        const tabPane = this.tabPane[i]
        levelIndex++
        let childrenIndex = 0
        for (const i2 in tabPane.children) {
          childrenIndex++
          const childrenData = tabPane.children[i2]
          const [pType, pMinLevel, pMaxLevel] = tabPane.label.split('-')
          const parentCond = {
            start: parseInt(pMinLevel),
            end: parseInt(pMaxLevel),
            shushu: [],
            type: pType
          }
          const [type, minLevel, maxLevel] = childrenData.label.split('-')
          let groupIndex = 0
          for (const i3 in childrenData.data) {
            const data = childrenData.data[i3]
            if (data.data.length <= 0) {
              continue
            }
            groupIndex++
            for (const i7 in data.data) {
              const _rewards = data.data[i7]
              for (const ii1 in _rewards.rewards.ranks) {
                const rank = _rewards.rewards.ranks[ii1]
                if (rank.rankPos <= 0) {
                  this.msgError('排名不能是0')
                  return
                }
                for (const k in rank.prize) {
                  const p = rank.prize[k]
                  if (p.type === 65) {
                    _rewards.rewards.ranks[ii1].prize[k].num *= 10000
                  }
                }
              }

              for (const ii2 in _rewards.rewards.stages) {
                const stages = _rewards.rewards.stages[ii2]
                if (stages.stage <= 0) {
                  this.msgError('阶段不能是0')
                  return
                }
                if (stages.stepnum <= 0) {
                  this.msgError('步骤进度不能是0')
                  return
                }
                if (stages.stageSpins <= 0) {
                  this.msgError('最低消耗体力不能是0')
                  return
                }
                for (const k in stages.prize) {
                  const p = stages.prize[k]
                  if (p.type === 65) {
                    _rewards.rewards.stages[ii2].prize[k].num *= 10000
                  }
                }
              }
            }

            const condition = {
              start: parseInt(minLevel),
              end: parseInt(maxLevel),
              shushu: [],
              type: type
            }

            const condition1 = {
              start: 0,
              end: 0,
              shushu: data.group,
              type: 'shushu'
            }

            const key = `${levelIndex}-${childrenIndex}-${groupIndex}`
            postFormDataCondition[key] = [parentCond, condition, condition1]

            const _data = data.data[0]
            _data.aid = this.aid
            _data.stage = key
            _postData.push(_data)
          }
        }

        for (const i6 in tabPane.data) {
          childrenIndex++
          const data1 = tabPane.data[i6]
          for (const i7 in data1.data) {
            const _rewards = data1.data[i7]
            for (const ii1 in _rewards.rewards.ranks) {
              const rank = _rewards.rewards.ranks[ii1]
              if (rank.rankPos <= 0) {
                this.msgError('排名不能是0')
                return
              }
              for (const k in rank.prize) {
                const p = rank.prize[k]
                if (p.type === 65) {
                  _rewards.rewards.ranks[ii1].prize[k].num *= 10000
                }
              }
            }

            for (const ii2 in _rewards.rewards.stages) {
              const stages = _rewards.rewards.stages[ii2]
              if (stages.stage <= 0) {
                this.msgError('阶段不能是0')
                return
              }
              if (stages.stepnum <= 0) {
                this.msgError('步骤进度不能是0')
                return
              }
              if (stages.stageSpins <= 0) {
                this.msgError('最低消耗体力不能是0')
                return
              }
              for (const k in stages.prize) {
                const p = stages.prize[k]
                if (p.type === 65) {
                  _rewards.rewards.stages[ii2].prize[k].num *= 10000
                }
              }
            }
          }
          const [type, minLevel, maxLevel] = tabPane.label.split('-')
          const condition = {
            start: parseInt(minLevel),
            end: parseInt(maxLevel),
            shushu: [],
            type: type
          }

          const condition1 = {
            start: 0,
            end: 0,
            shushu: data1.group,
            type: 'shushu'
          }

          const key = levelIndex + '-' + childrenIndex
          postFormDataCondition[key] = [condition, condition1]

          const _data = data1.data[0]
          _data.aid = this.aid
          _data.stage = key
          _postData.push(_data)
        }
      }
      const newPostData = JSON.parse(JSON.stringify(_postData))
      for (const i in newPostData) {
        const val = newPostData[i]
        const stages = val.rewards.stages
        const ranks = val.rewards.ranks
        newPostData[i].stages = stages
        newPostData[i].ranks = ranks
      }
      console.log('tabPane', this.tabPane)
      console.log('_postData', newPostData)
      const postCondition = JSON.stringify({ aid: this.aid, condition: postFormDataCondition })
      // const postFormData = JSON.stringify(_postData)
      const postFormData = JSON.stringify(newPostData)
      console.log('postCondition', postCondition)
      console.log('_postData', postFormData)
      updateActivtyRewardCfg({ id: this.aid, type: this.actType, name: postCondition, data: postFormData }).then(res => {
        if (res.code === 200) {
          this.msgSuccess(res.msg)
          this.getTables()
        } else {
          this.msgError(res.msg)
        }
      })
    },
    createParentTabPent(val) {
      const parentTemp = {
        label: '',
        type: '',
        bak_type: '',
        min_level: 0,
        max_level: 0,
        bak_min_level: 0,
        bak_max_level: 0,
        children: [],
        data: []
      }
      // const parentTemp = Object.assign({}, this.tabPaneTemp)
      parentTemp.label = `${val.type}-${val.start}-${val.end}`
      parentTemp.type = val.type
      parentTemp.bak_type = val.type
      parentTemp.min_level = val.start
      parentTemp.max_level = val.end
      parentTemp.bak_min_level = val.start
      parentTemp.bak_max_level = val.end
      for (const i in this.tabPane) {
        const tabPane = this.tabPane[i]
        if (tabPane.label === parentTemp.label) {
          return
        }
      }
      this.tabPane.push(parentTemp)
    },
    createChildrenTabPent(tabPane, children, group) {
      for (const i in tabPane.children) {
        const val = tabPane.children[i]
        if (val.label === children.label) {
          // 分组是否存在
          for (const i2 in val.data) {
            const g = val.data[i2]
            if (g.group_name === group.group_name) {
              return
            }
          }
          val.data.push(group)
          tabPane.children[i] = val
          return
        }
      }
      children.data.push(group)
      tabPane.children.push(children)
    },
    createTabPen(tabPane, obj) {
      for (const i in tabPane.data) {
        const val = tabPane.data[i]
        if (val.group_name === obj.group_name) {
          return
        }
      }
      tabPane.data.push(obj)
    },
    getStageCoefficient(id) {
      getStageCoefficientList({ id: id }).then(res => {
        if (res.code === 200) {
          this.stageCoefficient = res.data
        }
      })
    },
    getTables() {
      this.getStageCoefficient(this.aid)
      getActivtyRewardCfg({ id: this.aid }).then(res => {
        this.tabPane = []
        const cond = res.data.cond.condition
        const data = res.data.data
        for (const i in cond) {
          const condLen = cond[i].length
          const val = cond[i][0]
          const val1 = cond[i][1]
          this.createParentTabPent(val)
          let reward = [{ aid: 0, stage: [], rewards: [] }]
          const parentLabel = `${val.type}-${val.start}-${val.end}`
          const tabPane = this.getTabPane(parentLabel)
          this.levelActiveName = parentLabel
          for (const k in data) {
            const _data = data[k]
            const newStage = []
            const newRanks = []
            if (_data.stage === i) {
              for (const i1 in _data.rewards.stages) {
                const r = _data.rewards.stages[i1]
                for (const r1 in r.prize) {
                  const p = r.prize[r1]
                  if (p.type === 65) {
                    _data.rewards.stages[i1].prize[r1].num /= 10000
                  }
                }
                _data.rewards.stages[i1].draw = false
                newStage.push(_data.rewards.stages[i1])
              }
              for (const i1 in _data.rewards.ranks) {
                const r = _data.rewards.ranks[i1]
                for (const r1 in r.prize) {
                  const p = r.prize[r1]
                  if (p.type === 65) {
                    _data.rewards.ranks[i1].prize[r1].num /= 10000
                  }
                }
                _data.rewards.ranks[i1].draw = false
                newRanks.push(_data.rewards.ranks[i1])
              }
              _data.rewards.stages = newStage
              _data.rewards.ranks = newRanks
              _data.stageCoefficient = this.getStageCoefficientConfig(_data.stage)
              reward = [_data]
              break
            }
          }
          if (condLen > 2) {
            const val2 = cond[i][2]
            const parentTemp = {
              label: '',
              type: '',
              bak_type: '',
              min_level: 0,
              max_level: 0,
              bak_min_level: 0,
              bak_max_level: 0,
              children: [],
              data: []
            }
            // const parentTemp = Object.assign({}, this.tabPaneTemp)
            parentTemp.bak_min_level = val1.start
            parentTemp.bak_max_level = val1.end
            parentTemp.min_level = val1.start
            parentTemp.max_level = val1.end
            parentTemp.type = val1.type
            parentTemp.bak_type = val1.type
            parentTemp.label = `${val1.type}-${val1.start}-${val1.end}`
            parentTemp.data = []
            parentTemp.children = []
            const group = {
              'group': val2.shushu,
              'group_name': val2.shushu.join('-'),
              'group_bak': val2.shushu,
              'data': reward
            }
            console.log('i', i)
            // parentTemp.data.push(group)
            this.createChildrenTabPent(tabPane, parentTemp, group)
            this.levelActiveName2 = parentTemp.label
          } else {
            this.createTabPen(tabPane, {
              'group': val1.shushu,
              'group_name': val1.shushu.join('-'),
              'group_bak': val1.shushu,
              'data': reward
            })
          }
        }

        console.log('this.tabPane', this.tabPane)
      })
    },
    levelChangeType(newVal, levelName, isParent = 0, levelName2) {
      // 是否存在相同类型
      let fileIndex = -1
      this.tabPane.filter((res, index) => {
        if (res.label === levelName) {
          // eslint-disable-next-line no-unused-vars
          fileIndex = index
        }
      })

      if (fileIndex === -1) {
        this.msgError('修改失败')
        return
      }

      const oldTabPane = this.tabPane[fileIndex]
      let newLabelName = newVal + '-' + oldTabPane.min_level + '-' + oldTabPane.max_level
      if (!isParent) {
        for (const i in this.tabPane) {
          const tabPane = this.tabPane[i]
          if (tabPane.label === newLabelName) {
            this.msgError('当前类型配置已经存在')
            return
          }
        }
        oldTabPane.label = newLabelName
        this.tabPane[fileIndex] = oldTabPane
        this.levelActiveName = newLabelName
      } else {
        if (oldTabPane.label === newLabelName) {
          this.msgError('当前类型配置不能与父类型一致')
          return
        }
        let childrenTabPane = []
        let childrenTabIndex = 0
        for (const i in oldTabPane.children) {
          const val = oldTabPane.children[i]
          if (val.label === newLabelName) {
            this.msgError('当前类型配置已经存在')
            return
          }
        }

        for (const i in oldTabPane.children) {
          const val = oldTabPane.children[i]
          if (val.label === levelName2) {
            childrenTabPane = val
            childrenTabIndex = i
            break
          }
        }
        newLabelName = newVal + '-' + childrenTabPane.min_level + '-' + childrenTabPane.max_level
        childrenTabPane.label = newLabelName
        this.tabPane[fileIndex].children[childrenTabIndex] = childrenTabPane
        this.levelActiveName2 = newLabelName
      }
    },
    levelChange(newVal, isMin, type, bakMin, bakMax, isParent = 0, parentLabel, levelName2) {
      newVal = parseInt(newVal)
      let oldLevelName = type + '-' + bakMin + '-' + bakMax
      if (isParent) {
        oldLevelName = parentLabel
      }
      let newLevelName = ''
      if (isMin) {
        newLevelName = type + '-' + newVal + '-' + bakMax
      } else {
        newLevelName = type + '-' + bakMin + '-' + newVal
      }
      let fileIndex = -1
      this.tabPane.filter((res, index) => {
        if (res.label === oldLevelName) {
          // eslint-disable-next-line no-unused-vars
          fileIndex = index
        }
      })
      console.log(fileIndex)
      if (fileIndex > -1) {
        const oldTab = this.tabPane[fileIndex]
        let childrenTabPane = []
        let childrenTabIndex = 0
        if (isParent) {
          for (const i in oldTab.children) {
            const val = oldTab.children[i]
            if (val.label === levelName2) {
              childrenTabPane = val
              childrenTabIndex = i
              break
            }
          }

          if (isMin) {
            childrenTabPane['bak_min_level'] = newVal
            childrenTabPane['min_level'] = newVal
          } else {
            childrenTabPane['bak_max_level'] = newVal
            childrenTabPane['max_level'] = newVal
          }
          childrenTabPane['label'] = newLevelName
          this.tabPane[fileIndex].children[childrenTabIndex] = childrenTabPane
          this.levelActiveName2 = newLevelName
        } else {
          oldTab['label'] = newLevelName
          if (isMin) {
            oldTab['bak_min_level'] = newVal
            oldTab['min_level'] = newVal
          } else {
            oldTab['bak_max_level'] = newVal
            oldTab['max_level'] = newVal
          }
          this.tabPane[fileIndex] = oldTab
          this.levelActiveName = newLevelName
        }
      }
    },
    addEventReward(levelName, scoreName, index, i) {
      console.log(this.formData[levelName][scoreName].data[index].config[i])
      let propsId = 14
      if (this.formData[levelName][scoreName].data[index].config[i].type === 3) {
        propsId = 1
        if (this.formData[levelName][scoreName].data[index].config[i].reward.length >= 1) {
          return
        }
      }
      this.formData[levelName][scoreName].data[index].config[i].reward.push({
        propsId: propsId,
        skin: 0,
        num: 0,
        rtype: 2
      })
    },
    addEvent1(levelName, scoreName, index) {
      this.formData[levelName][scoreName].data[index].config.push({
        aid: 1,
        reward: [{
          state: 1,
          stepnum: 1,
          prize: [
            {
              id: 1,
              num: 1,
              skin: 0,
              rtype: 2,
              type: 2,
              is_ts: 0
            }],
          progressBarId: 1,
          stageSpins: 1
        }],
        stage: []
      })
    },
    delEvent1(key, levelName, index, scoreIndex, isParent = false, score_index) {
      const tabPane = this.getTabPane(levelName)
      if (!tabPane) {
        this.msgError('添加失败,未找到元素')
        return
      }

      console.log('index', index)
      console.log('scoreIndex', scoreIndex)
      console.log('删除kEY', score_index)
      console.log('children', tabPane.children)
      console.log('delEvent1', tabPane.children[index])
      if (isParent) {
        tabPane.children[index].data[scoreIndex].data[0].rewards[key] = tabPane.children[index].data[scoreIndex].data[0].rewards[key].filter((item, k) => {
          return score_index !== k
        })
        let count = 0
        tabPane.children[index].data[scoreIndex].data[0].rewards[key].forEach((res, idx) => {
          count++
          tabPane.children[index].data[scoreIndex].data[0].rewards[key][idx].stage = count
        })
      } else {
        tabPane.data[index].data[0].rewards[key] = tabPane.data[index].data[0].rewards[key].filter((item, k) => {
          return scoreIndex !== k
        })
        let count = 0
        tabPane.data[index].data[0].rewards[key].forEach((res, idx) => {
          count++
          tabPane.data[index].data[0].rewards[key][idx].stage = count
        })
      }
    },
    addEvent(key, levelName, scoreIndex, isParent = 0, parentIndex = 0) {
      const tabPane = this.getTabPane(levelName)
      if (!tabPane) {
        this.msgError('添加失败,未找到元素')
        return
      }

      if (key === 'ranks') {
        if (isParent) {
          const len = tabPane.children[parentIndex].data[scoreIndex].data[0].rewards[key].length
          tabPane.children[parentIndex].data[scoreIndex].data[0].rewards[key].push({
            draw: false,
            rankPos: len + 1,
            prize: []
          })
        } else {
          const len = tabPane.data[scoreIndex].data[0].rewards[key].length
          tabPane.data[scoreIndex].data[0].rewards[key].push({
            draw: false,
            rankPos: len + 1,
            prize: []
          })
        }
      } else {
        if (isParent) {
          const len = tabPane.children[parentIndex].data[scoreIndex].data[0].rewards[key].length
          tabPane.children[parentIndex].data[scoreIndex].data[0].rewards[key].push({
            draw: false,
            stage: len + 1,
            stepnum: 1,
            lv: 1,
            stagePro: [],
            prize: [],
            progressBarId: 1,
            stageSpins: 1
          })
          console.log('data1', tabPane.children[parentIndex])
        } else {
          console.log('addEvent', tabPane.data[scoreIndex].data[0])
          const len = tabPane.data[scoreIndex].data[0].rewards[key].length
          tabPane.data[scoreIndex].data[0].rewards[key].push({
            draw: false,
            stage: len + 1,
            stepnum: 1,
            lv: 1,
            stagePro: [],
            prize: [],
            progressBarId: 1,
            stageSpins: 1
          })
        }
      }
    },
    delEvent(levelName, scoreIndex, isParent = 0, index = 0) {
      const tabPane = this.getTabPane(levelName)
      if (isParent) {
        tabPane.children[index].data = tabPane.children[index].data.filter((item, idx) => {
          return idx !== scoreIndex
        })
      } else {
        tabPane.data = tabPane.data.filter((item, index) => {
          return index !== scoreIndex
        })
      }
      // if (isParent) {
      //   const tabPane = this.getTabPane(levelName)
      //   tabPane.children[index].data = tabPane.children[index].data.filter((res, key) => {
      //     return scoreIndex !== key
      //   })
      // } else {
      //   if (id > 0) {
      //     this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
      //       confirmButtonText: '确定',
      //       cancelButtonText: '取消',
      //       type: 'warning'
      //     }).then(() => {
      //       delActivtyRewardCfg({ id: id }).then(res => {
      //         if (res.code === 200) {
      //         // this.formData[levelName][scoreName].data = []
      //           this.$delete(this.formData[levelName], scoreName)
      //           // this.msgSuccess(res.msg)
      //           this.onSubmit(true)
      //         // this.getTables()
      //         } else {
      //         // this.msgError(res.msg)
      //         }
      //       })
      //     }).catch(() => {
      //       this.$message({
      //         type: 'info',
      //         message: '已取消删除'
      //       })
      //     })
      //   }
      // }
    },
    addScoreEvent(levelName, parent, index) {
      this.scoreFormData.max_score = 0
      this.scoreFormData.min_score = 0
      this.scoreFormData.parent = parent
      this.scoreFormData.index = index
      this.scoreFormData.level_name = levelName
      this.dialogVisibleScoreEvent = true
    },
    addGroup() {
      const score = this.scoreFormData
      const parent = score.parent
      const index = score.index
      console.log('parent', parent)
      if (score.group.length <= 0) {
        this.msgError('请选择分组')
        return
      }
      this.dialogVisibleScoreEvent = false
      const bakGroup = score.group
      const scoreTag = score.group.join('-')
      let label = score.level_name
      if (parent !== '') {
        label = parent
      }
      let tabPaneEdit = []
      for (const i in this.tabPane) {
        const tabPane = this.tabPane[i]
        if (tabPane.label === label) {
          tabPaneEdit = tabPane
          break
        }
      }

      if (!tabPaneEdit) {
        this.msgError('添加失败,未找到元素')
        return
      }

      if (parent !== '') {
        for (const i in tabPaneEdit.children[index].data) {
          const g = tabPaneEdit.children[index].data[i]
          if (g.group_name === scoreTag) {
            this.msgError('添加失败,当前分组已经存在')
            return
          }
        }
        tabPaneEdit.children[index].data.push({
          'group': bakGroup,
          'group_name': scoreTag,
          'group_bak': bakGroup,
          'data': [{ aid: 0, stageCoefficient: [], stage: [], rewards: { ranks: [], stages: [] }}]
        })
      } else {
        for (const i in tabPaneEdit.data) {
          const g = tabPaneEdit.data[i]
          if (g.group_name === scoreTag) {
            this.msgError('添加失败,当前分组已经存在')
            return
          }
        }
        tabPaneEdit.data.push({
          'group': bakGroup,
          'group_name': scoreTag,
          'group_bak': bakGroup,
          'data': [{ aid: 0, stageCoefficient: [], stage: [], rewards: { ranks: [], stages: [] }}]
        })
      }

      // 添加第一个元素
      this.activeName = score.level_name
      this.scoreFormData.group = []
      this.scoreFormData.group_bak = []
      this.scoreFormData.group_name = ''
    },
    addLevel() {
      const parent = this.levelFormData.parent
      const index = this.levelFormData.index
      console.log('添加等级', 'label', parent, 'index', index)
      this.dialogVisible = false
      if (this.levelFormData.min_level > this.levelFormData.max_level) {
        this.msgError('最低等级不能大于最大等级')
        return
      }
      const levelName = this.levelFormData.type + '-' + this.levelFormData.min_level + '-' + this.levelFormData.max_level
      console.log('parent', parent)
      if (parent !== '') {
        if (this.tabPane[index].label === levelName) {
          this.msgError('父级类型不能和当前所有类型相同')
          return
        }
        for (const i in this.tabPane[index].children) {
          const tabPane = this.tabPane[index].children[i]
          if (tabPane.type === this.levelFormData.type && tabPane.label === levelName) {
            this.msgError('当前配置已经存在')
            return
          }
        }
      } else {
        for (const i in this.tabPane) {
          const tabPane = this.tabPane[i]
          if (tabPane.type === this.levelFormData.type && tabPane.label === levelName) {
            this.msgError('当前配置已经存在')
            return
          }
        }
      }

      const tabPane = {
        label: levelName,
        type: this.levelFormData.type,
        bak_type: this.levelFormData.type,
        min_level: this.levelFormData.min_level,
        max_level: this.levelFormData.max_level,
        bak_min_level: this.levelFormData.min_level,
        bak_max_level: this.levelFormData.max_level,
        children: [],
        data: []
      }

      if (index > -1) {
        this.tabPane[index].children.push(tabPane)
        this.levelActiveName2 = levelName
      } else {
        this.tabPane.push(tabPane)
        this.levelActiveName = levelName
      }
    },
    handleClick(tab, event) {
      console.log(tab.name)
      this.activeName = tab.name
    },
    scoreChange(newVal, isMin, levelName, minBak, maxBak) {
      console.log('scoreChange', newVal)
      const oldScoreName = minBak + '-' + maxBak
      let newScoreName = newVal + '-' + maxBak
      if (!isMin) {
        newScoreName = minBak + '-' + newVal
      }
      const oldData = this.formData[levelName][oldScoreName]

      if (isMin) {
        oldData.min_score = newVal
        oldData.min_score_bak = newVal
      } else {
        oldData.max_score = newVal
        oldData.max_score_bak = newVal
      }

      // // 删除旧积分
      Vue.delete(this.formData[levelName], oldScoreName)
      this.$set(this.formData[levelName], newScoreName, oldData)
      console.log(this.formData[levelName])
    },
    getRewardTypeData(uc_type) {
      getRewardType({ data: uc_type }).then(res => {
        if (res.code === 200) {
          for (const i in res.data) {
            this.rewardType.push({ 'label': res.data[i], 'value': parseInt(i) })
          }
        }
      })
    },
    addReward(key, levelName, index, scoreIndex, isParent = false, parentIndex = 0) {
      const tabPane = this.getTabPane(levelName)
      if (!tabPane) {
        this.msgError('奖励添加失败,未找到元素')
        return
      }
      console.log('index', index)
      // console.log('parentIndex', parentIndex)
      // console.log('scoreIndex', scoreIndex)
      console.log('children', tabPane.data[index])
      // console.log('addReward', tabPane.children[index].data[scoreIndex].data[0])
      if (isParent) {
        tabPane.children[index].data[scoreIndex].data[0].rewards[key][parentIndex].prize.push(
          {
            id: 0,
            num: 0,
            type: 1,
            rtype: 1,
            is_ts: 0,
            skin: 0,
            ts: 0
          }
        )
      } else {
        tabPane.data[index].data[0].rewards[key][scoreIndex].prize.push(
          {
            id: 0,
            num: 0,
            type: 1,
            rtype: 1,
            is_ts: 0,
            skin: 0,
            ts: 0
          }
        )
      }
    },
    delReward(levelName, groupName, index, i) {
      this.formData[levelName][groupName].data[index].reward = this.formData[levelName][groupName].data[index].reward.filter((item, key) => {
        return key !== i
      })
    },
    groupChange(v, levelName, oldGroupName, isParent = false, index, scoreIndex) {
      v = v.sort()
      const newGroupName = v.join('-')
      // oldData.group = v
      // oldData.group_bak = v
      // oldData.group_name = newGroupName
      const tabPane = this.getTabPane(levelName)
      if (isParent) {
        tabPane.children[index].data[scoreIndex].group = v
        tabPane.children[index].data[scoreIndex].group_name = newGroupName
        tabPane.children[index].data[scoreIndex].group_bak = v
      } else {
        tabPane.data[0].group = v
        tabPane.data[0].group_name = newGroupName
        tabPane.data[0].group_bak = v
      }
    },
    getChessBoardType() {
      getChessBoardType().then(res => {
        if (res.code === 200) {
          for (const i in res.data) {
            this.chessBoardType.push({ 'title': res.data[i], 'id': parseInt(i) })
          }
        }
      })
    },
    removeReward(key, levelName, index, scoreIndex, i, isParent = false, parentIndex = 0) {
      const tabPane = this.getTabPane(levelName)
      if (!tabPane) {
        this.msgError('奖励删除失败,未找到元素')
        return
      }
      console.log('index', index)
      console.log('isParent', isParent)
      console.log('scoreIndex', scoreIndex)
      console.log('removeReward1', tabPane.children[parentIndex])
      // console.log('removeReward', tabPane.children[parentIndex].data[scoreIndex])
      if (isParent) {
        tabPane.children[parentIndex].data[scoreIndex].data[0].rewards[key][index].prize = tabPane.children[parentIndex].data[scoreIndex].data[0].rewards[key][index].prize.filter((item, key) => {
          return i !== key
        })
      } else {
        tabPane.data[index].data[0].rewards[key][scoreIndex].prize = tabPane.data[index].data[0].rewards[key][scoreIndex].prize.filter((item, key) => {
          return i !== key
        })
      }
    }, getLabelName(label) {
      const arr = label.split('-')
      let typeName = ''
      this.conditionType.forEach((item) => {
        if (item.value === arr[0]) {
          typeName = item.label
        }
      })
      return typeName + '-Lv:' + arr[1] + '-' + arr[2]
    }, mtTypeChange(v, levelName, groupName, index) {
      this.formData[levelName][groupName].data[0].rewards[index].sku = ''
    }, getRewardList(prize) {
      return getRewardListForType(prize, this.rewardType)
    }, delCond(label) {
      this.$confirm('此操作将永久删除该条件, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.tabPane = this.tabPane.filter(item => {
          return item.label !== label
        })

        this.onSubmit(false, true)
      })
    },
    checkFormData(label) {
      let count = 0
      for (const i in this.formData[label]) {
        const val = this.formData[label][i]
        count += val.data[0].rewards.length
      }

      if (count > 0) {
        return true
      }

      return false
    },
    getGroup() {
      getUserTypeAllList().then(res => {
        if (res.code === 200) {
          res.data.forEach(res => {
            this.groups.push({ label: res.name, value: res.groupId })
          })
        } else {
          this.msgError(res.msg)
        }
      })
    },
    getTabPane(levelName) {
      let tabPane = []
      for (const i in this.tabPane) {
        const val = this.tabPane[i]
        if (val.label === levelName) {
          tabPane = val
          break
        }
      }
      return tabPane
    },
    saveTabPane(levelName, tabPane) {
      for (const i in this.tabPane) {
        const val = this.tabPane[i]
        if (val.label === levelName) {
          this.tabPane[i] = tabPane
          break
        }
      }
    },
    delChildren(levelName, index) {
      const tabPane = this.getTabPane(levelName)
      this.$confirm('您确定要删除吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        tabPane.children = tabPane.children.filter((res, key) => {
          return key !== index
        })
      })
    },
    handleTableClick(tab, event) {
      this.activeName = tab.name
    },
    onSubmitVipSet() {
      const robotJson = {}
      const postData = this.vipSet
      for (const i in postData) {
        if (i === 'robot') {
          let idx = 0
          const robot = postData[i]
          robot.forEach((item, index) => {
            if (idx > 10) {
              idx = 49
            }
            postData[i][index].co1 = parseFloat(item.co1)
            postData[i][index].co2 = parseFloat(item.co2)
            postData[i][index].id = idx
            robotJson[idx.toString()] = item
            idx++
          })
        }
      }
      postData.robot = robotJson
      const data = JSON.stringify(postData)
      updateActivtyExtraData({ name: this.aid, data: data }).then(res => {
        if (res.code === 200) {
          this.msgSuccess(res.msg)
          this.getExtraData()
        } else {
          this.msgError(res.msg)
        }
      })
    },
    delBot(index) {
      this.vipSet.robot = this.vipSet.robot.filter((item, i) => {
        return index !== i
      })
      let id = 0
      this.vipSet.robot.forEach((item, index) => {
        id++
        this.vipSet.robot[index].id = id
      })
    },
    addBot() {
      const len = this.vipSet.robot.length
      if (len >= 12) {
        this.msgError('最多添加12个机器人')
        return
      }
      this.vipSet.robot.push({
        id: len + 1,
        pro: 0,
        num: 0,
        co1: 0,
        co2: 0
      })
    },
    getExtraData() {
      getActivtyList({ id: this.aid }).then(res => {
        if (res.code === 200) {
          const extra = res.data.list[0].extraData
          const robot = []
          for (const i in extra.robot) {
            robot.push(extra.robot[i])
          }
          delete extra.robot
          extra.robot = robot
          if (!extra.setType) {
            extra.setType = 1
          }
          if (!extra.spinsSet) {
            extra.spinsSet = this.vipSet.spinsSet
          }
          if (!extra.spinsSetSpins) {
            extra.spinsSetSpins = this.vipSet.spinsSetSpins
          }
          if (!extra.vipSet) {
            extra.vipSet = this.vipSet.vipSet
          }
          if (!extra.vipSetSpins) {
            extra.vipSetSpins = this.vipSet.vipSetSpins
          }

          this.vipSet = extra
        }
      })
    },
    addRankLimit(index) {
      this.vipSet.rankLimit.push({ time: 1, limit: 1 })
    }, delRankLimit(index) {
      this.vipSet.rankLimit = this.vipSet.rankLimit.filter((item, i) => {
        return index !== i
      })
    },
    getStageCoefficientConfig(stage) {
      let stageConfig = []
      this.stageCoefficientHeader = ['阶段']
      for (let i = 0; i <= 4; i++) {
        const index = parseInt(i) + 1
        this.stageCoefficientHeader.push('进度' + index)
        this.stageCoefficientHeader.push('系数' + index)
      }

      for (const i in this.stageCoefficient) {
        const val = this.stageCoefficient[i]
        if (val.stage === stage) {
          stageConfig = val.config
          break
        }
      }
      const newStageConfig = []
      for (const i in stageConfig) {
        newStageConfig[i] = []
        const val = stageConfig[i]
        const index = parseInt(i) + 1
        newStageConfig[i].push(index)
        for (const k in val) {
          const stage = val[k]
          newStageConfig[i].push(stage.progress, stage.coefficient)
        }
      }
      console.log('newStageConfig', newStageConfig)
      return newStageConfig
    },
    typeChange(v) {
      // if (this.activtyToTypeId.includes(v)) {
      let typ = ''
      if (v) {
        typ = this.activtyToType[v]
      }
      getActivtyAllList({ type: typ }).then(res => {
        if (res.code === 200) {
          this.activtyList = res.data
        }
      })
    },
    getActivtyToType() {
      getActivityTypeToMap().then(res => {
        if (res.code === 200) {
          this.activtyToType = res.data
          for (const i in res.data) {
            this.activtyToTypeId.push(parseInt(i))
          }
        } else {
          this.msgError(res.msg)
        }
      })
    }
  }
}
</script>

<style scoped>
</style>
